module.exports = __webpack_public_path__ + "static/media/search.453ddecb.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/search.svg
// module id = 535
// module chunks = 1